import { type FlowValueFormat, formatFlowAmount } from './flowFormat'
import { type FlowHeading, HEADING_BASELINE } from './flowLayout'

const TOTAL_LINE_GAP = 14

// Each column's title over its total, lined up with its labels' side.
export function FlowHeadings({
  headings,
  valueFormat,
}: {
  headings: FlowHeading[]
  valueFormat: FlowValueFormat
}) {
  return (
    <g className="pointer-events-none select-none">
      {headings.map((heading) => (
        <text
          key={heading.role}
          x={heading.x}
          y={HEADING_BASELINE}
          textAnchor={heading.side === 'left' ? 'end' : 'start'}
          fontSize={12}
          fontWeight={600}
          className="fill-foreground"
        >
          {heading.title}
          <tspan
            x={heading.x}
            dy={TOTAL_LINE_GAP}
            fontSize={11}
            fontWeight={400}
            className="fill-muted-foreground"
          >
            {formatFlowAmount(heading.total, valueFormat)}
          </tspan>
        </text>
      ))}
    </g>
  )
}
